import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dispatch-tracking-listview',
  templateUrl: './dispatch-tracking-listview.component.html',
  styleUrls: ['./dispatch-tracking-listview.component.css']
})
export class DispatchTrackingListviewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
